import React, { useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { FiEdit3, FiTrash2 } from "react-icons/fi";

import FadeLoader from "react-spinners/FadeLoader";
import { FcCancel } from "react-icons/fc";
import StatusDropdown from '../MyWorklist/StatusDropdown'
import { BiSortAlt2 } from "react-icons/bi";
import Popover from '@mui/material/Popover';
import { fetchParkinglotDetailsbyentityid } from '../../Services/parkinglotService'
import OwnerPropertyImage from '../../Images/Frame.jpg';
import ValidationMessages from "../utils/validationMessages";
import SelectPricingPlan from '../Settings/SelectPricingPlan';

const OwnerParkinglotRegistration = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);  // State to track anchor element for the popup
    const [selectedRowData, setSelectedRowData] = useState(null);
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
    const [filter, setFilter] = useState([]);
    const [search] = useState("");
    const [,setPopupVisible] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [updateData, setUpdateData] = useState(false);

    const [selectedStatus, setSelectedStatus] = useState(''); // This will store the selected status
    const [sortDirection, setSortDirection] = useState('asc'); // State for sorting direction
    const stateLogedInUser = props.entityId;
    const [isSelectPricingOpen, setIsSelectPricingOpen] = useState(false);
    const fetchParkinglotdetails = async () => {
        setLoader(true);  // Show loader before fetching data
        try {
            const parkingDetails = await fetchParkinglotDetailsbyentityid(stateLogedInUser);
            setParkingLotBookingDetails(parkingDetails);  // Set fetched data

        } catch (error) {
            console.error("Error fetching parking lot details:", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchParkinglotdetails();
    }, [updateData]);
    useEffect(() => {
        let result = parkingLotBookingDetails;

        // Filter by search query
        if (search) {
            result = result.filter((item) => {
                return (item.parkingLotAddress || item.createdDate).toLowerCase().includes(search.toLowerCase());
            });
        }

        // Filter by selected status
        if (selectedStatus.length > 0) {
            result = result.filter((item) => selectedStatus.includes(item.status));
        }

        setFilter(result);
    }, [search, parkingLotBookingDetails, selectedStatus]);
    const handleDelete = (val, typeOfButton) => {
        let message;
        let message2;
        let status;
        if (typeOfButton === 'trash') {
            message = ValidationMessages.actionIrreversible;
            message2 = ValidationMessages.proceed
            status = 'delete';
        } else if (typeOfButton === 'cancel') {
            message = ValidationMessages.propInactive;
            message2 = ValidationMessages.makeActive
            status = val.status === 'Active' ? 'Inactive' : 'Active'
        }
        else if (typeOfButton === 'active') {
            message = ValidationMessages.propActive;
            message2 = ValidationMessages.confirmContinue
            status = val.status === 'Inactive' ? 'Active' : 'Inactive'
        }

        let data = { EmailId: val.emailId, Parking_Lot_ID: val.parking_Lot_ID, message, message2, status, val };
        setRowData(data);
        setOpen(true);
        setPopupVisible(false);
    };
    const handleConfirm = (text, status, val) => {
        if (text === 'confirm') {
            if (status === 'delete') {
                setLoader(true)
                const requestOptions = {
                    method: 'POST',
                    headers: { "x-functions-key": hostHeader },
                    body: JSON.stringify(rowData)
                };
                axios.post(`${hostPath}/api/DeleteParkingLotDetailsByEmailId`, requestOptions.body, { headers: requestOptions.headers })
                    .then(response => {
                        if (response.data) {
                            if (response.data.status) {
                                const newdata = parkingLotBookingDetails.filter((item) => item.parking_Lot_ID !== rowData.Parking_Lot_ID);
                                setParkingLotBookingDetails(newdata);
                                setFilter(newdata);
                                setOpen(false);
                            }
                            else {
                                alert(response.data.responseMessage);
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    }).finally(() => {
                        // setLoader(false)
                        setUpdateData(!updateData);

                    })
            }
            else if (status === 'Inactive' || status === 'Active') {
                setLoader(true)
                const CoardinateDetails = val?.coardinateDetails;
                const Scheduleavailability = val?.scheduleavailability
                const parkinglot = {
                    "EmailId": val?.emailId,
                    "EmpId": val?.empId,
                    "NickName": val?.nickName,
                    "EntityRegistrationID": val?.entityRegistrationID,
                    "ParkingLotAddress": val?.parkingLotAddress,
                    "Parking_Lot_ID": val?.parking_Lot_ID,
                    "id": val?.id,
                    "CreatedDate": val?.createdDate,
                    "Status": status,
                    "Comment": val?.comment,
                    "StreetName": val?.streetName,
                    "BankDetailID": val?.bankDetailID,
                    CoardinateDetails,
                    Scheduleavailability
                };
                axios.post(`${hostPath}/api/UpdateParkingLotDetails`, parkinglot, {
                    headers: {
                        "x-functions-key": hostHeader
                    }
                })
                    .then(response => {
                        if (response.data) {
                            setOpen(false);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    }).finally(() => {
                        // setLoader(false)
                        setUpdateData(!updateData);
                    })
                    ;
            }
        }
        else if (text === 'cancel') {
            setOpen(false);
        }
    };

    const handleEdit = (e, val) => {
        setSelectedRowData(val);
        setAnchorEl(e.currentTarget);  // Set the clicked element as the anchor for the popup
    };

const handleEdittomap = (val) => {
    console.log("valTest",val);
    
    props.onSetParkingLotObj(val);
    props.onSetDefaultAddress(val?.parkingLotAddress);
    
    const transformedAreas = val?.coardinateDetails?.map(details => ({
        Coordinates: {
            Title: details?.title || 'Unknown',
            Latitude: parseFloat(details?.latitude) || 0,
            Longitude: parseFloat(details?.longitude) || 0,
            
        },
        Name: details?.title || 'Unknown',
        id: parseInt(details?.id, 10) || 0,
        VehicleSpotSize: details?.vechileSpotSize || '',
        pslName: details?.pslName || '',
        groupName: Array.isArray(details?.groupName) 
            ? (details.groupName[0] || 'Default') 
            : (details?.groupName || 'Default'),
        latandlong: `Latitude: ${parseFloat(details?.latitude) || 0} Longitude: ${parseFloat(details?.longitude) || 0}`,
        // ✅ ADD THIS LINE HERE:
        ScheduleAvailability: details?.scheduleavailability || []
    }));
    console.log(transformedAreas,"transformedAreasTest");
    
    props.onSetAreasMarked(transformedAreas);
    props.handleSetEdit(true);
    setPopupVisible(false);

};

   
    const handleStatusChange = (selectedStatus) => {
        setSelectedStatus(selectedStatus);
    };
    const handleSort = (column) => {
        // Toggle the sorting direction
        const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newSortDirection);

        // Sort the data based on the 'createdDate' field
        const sortedData = [...filter].sort((a, b) => {
            const dateA = new Date(a[column]);
            const dateB = new Date(b[column]);

            if (newSortDirection === 'asc') {
                return dateA - dateB;
            } else {
                return dateB - dateA;
            }
        });

        setFilter(sortedData);
    };
    const columns = [
        {
            name: "Nickname",
            selector: (row) => row.nickName
        },
        {
            name: "Street Address",
            cell: (row) => (
                <div
                    style={{ cursor: 'pointer' }}  // Style to indicate it's clickable
                    onClick={(e) => handleEdittomap(row)} // Call function when clicked
                >
                    {row.parkingLotAddress}
                </div>
            ),
        },

        {
            name: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                    Parking Spaces Selected
                </div>
            ),
            selector: (row) =>
                row?.coardinateDetails?.filter((coord) => coord.title === "PSL - Parking Space Location").length || 0,
            grow: 1,
            wrap: true,
        },

        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort('createdDate')}>
                    Created Date <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.createdDate,
        },
        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort("lastUpdatedDate")}>
                    Last Updated <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.lastUpdatedDate,
        },
        {
            name: "Pricing Plan",
            cell: (row) => {
                const plans =
                row.coardinateDetails
                    ?.map((coord) => coord.pricingPlanName)
                    .filter((name) => !!name && name.trim() !== ""); // remove null/empty

                const uniquePlans = [...new Set(plans)]; // remove duplicates

                return (
                <div style={{ cursor: "pointer" }}>
                    {uniquePlans.length > 0 ? uniquePlans.join(", ") : " "}
                </div>
                );
            },
        },


        {
            name: (
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <StatusDropdown handleStatusChange={handleStatusChange} />
                </div>
            ),
            selector: (row) => row?.status,
        },
        {
            name: "Actions",
            cell: (row) => (

                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0px' }}>
                    {row.status === 'Inactive' ? (
                        <>
                            {/* Show "Activate" icon for inactive status */}
                            <FiEdit3 title="Activate" aria-label="Activate"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                    color: "green"
                                }}
                                onClick={() => handleDelete(row, 'active')}  // Change status to Active
                            />
                        </>
                    ) : (
                        <>
                            {/* Show default edit and delete icons for active status */}
                            <FiEdit3 title="Edit" aria-label="Edit"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                }}
                                onClick={(e) => handleEdit(e, row)} />
                            <FiTrash2 title="Delete" aria-label="Delete"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                }}
                                onClick={() => handleDelete(row, 'trash')}  // Pass 'trash' as the type
                            />
                            <FcCancel
                                title={row.status === 'Active' ? 'Inactive' : 'Disabled'}
                                aria-label="Inactive"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: row.status === 'Active' ? "pointer" : "not-allowed",
                                    justifyContent: "center",
                                    opacity: row.status === 'Active' ? 1 : 0.5, // visually show it's disabled
                                }}
                                onClick={row.status === 'Active' ? () => handleDelete(row, 'cancel') : null}
                            />
                        </>
                    )}
                </div>
            ),
        },
    ];

    const tableHeaderStyle = {
        headCells: {
            style: {
                height: "90px",
                fontWeight: 800,
                fontSize: "16px",
                backgroundColor: "white",
                lineHeight: "19.2px",
                fontFamily: "Lato",
                textAlign: "left",
                borderBottom: "none"
            },
        },
    };

    const handleClose = () => {
        setAnchorEl(null);  // Close the popup
    };

    const Isopen = Boolean(anchorEl);  // Boolean to check if the popup is open
    const id = Isopen ? 'edit-popover' : undefined;

    const handleOptionClick = (option) => {
        props.onSetEditOption(option);
        setAnchorEl(null);  // Close the popup after selecting an option
        handleEdittomap(selectedRowData);
        if (option === 'parkingspaces') {
            handleEdittomap(selectedRowData);
        }
    };
    
    const handlePricingPlanClick = () => {
        setIsSelectPricingOpen(true);
        handleClose();
    };

    const handleCancelSelectPricing = (e) => {
        e?.stopPropagation?.();
        setIsSelectPricingOpen(false);
    };

    const handleConfirmSuccess = () => {
        setIsSelectPricingOpen(false);
        setUpdateData(!updateData);
    };

    

    const AddProperty = (e) => {
        e.preventDefault();
        props.handleEdit(e, props?.OwnerDetails)
    }
    const pslCount = selectedRowData?.coardinateDetails?.filter(c => c.title === "PSL - Parking Space Location").length || 0;

    const defaultPlanIdForLot =  selectedRowData?.coardinateDetails?.[0]?.pricingPlanID || null;
    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            {parkingLotBookingDetails.length > 0 ? (
                <div>
                    <div className='container-fluid p-0'>
                        {/* Heading with two lines */}
                        <div className="lotmanagement">
                            <div style={{ textAlign: 'center', position: 'relative', top: '-35px' }}>
                                <hr style={{
                                    border: 'none', borderTop: '1px solid #000', margin: '0 20px',
                                    width: '80%', padding: '0 15%', margin: '0 auto',
                                }} />
                                <h3 style={{
                                    display: 'inline-block',
                                    position: 'relative',
                                    backgroundColor: '#fff',
                                    padding: '0 10px',
                                    top: '-12px',  // Move the heading slightly up
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Properties
                                </h3>
                            </div>
                            <React.Fragment>
                                <div className="table-container">
                                    <DataTable
                                        customStyles={{
                                            headCells: tableHeaderStyle.headCells,
                                            cells: {
                                                style: {
                                                    fontFamily: 'Lato',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    lineHeight: '18.6px',
                                                    textAlign: 'left',
                                                    height: "50px",
                                                    borderBottom: "none",
                                                },
                                            },
                                        }}
                                        columns={columns}
                                        data={filter.length ? filter : []}  // Pass empty array to prevent row rendering
                                        pagination
                                        fixedHeader
                                        selectableRowsHighlight
                                        highlightOnHover
                                        persistTableHead
                                        style={{ width: '50%' }}
                                        noDataComponent={
                                            <div style={{ padding: '20px 0', textAlign: 'center' }}>
                                                No records found
                                            </div>
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        </div>
                    </div>
                    <Dialog
                        classes={{ paper: 'custom-paper-class-delete' }}
                        aria-labelledby="customized-dialog-title"
                        dividers
                        open={open}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
                            {rowData?.message}  {/* Display different messages based on the button clicked */}
                        </DialogTitle>
                        <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
                            <Typography gutterBottom>
                                <span>{rowData?.message2}</span>
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'right' }}>
                            <Button
                                className='custom-button-cancel'
                                onClick={() => handleConfirm('cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='custom-button-delete'
                                onClick={() => handleConfirm('confirm', rowData?.status, rowData?.val)}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Popover
                        id={id}
                        open={Isopen}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',  // Popup will appear to the left of the clicked icon
                            height: '500px',
                            width: '500px'
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',  // Popup will align to the right side of the anchor element
                        }}
                    >
                        <div style={{ padding: '10px' }}> {/* Additional padding for content */}
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('parkingspaces')}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }} // Ensure alignment
                            >
                                Parking Spaces
                            </Button>
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('parkingschedule')}
                                disabled={pslCount === 0}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }} // Ensure alignment
                            >
                                Parking Schedule
                            </Button>
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('bankdetails')}
                                disabled={pslCount === 0}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }} // Ensure alignment
                            >
                                Bank Details
                            </Button>
                            <Button
                                variant="text"
                                onClick={handlePricingPlanClick}
                                disabled={pslCount === 0}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
                            >
                                Pricing Plan
                            </Button>
                        </div>
                    </Popover>
                    {isSelectPricingOpen && (
                            <div className="popup-overlay" onClick={(e) => e.stopPropagation()}>
                                <div className="popup-content">
                                    <SelectPricingPlan
                                        entityId={stateLogedInUser}
                                        parkingLotId={selectedRowData?.parking_Lot_ID}
                                        currentPlanId={defaultPlanIdForLot}
                                        setIsSelectPricingOpen={setIsSelectPricingOpen}
                                        handleCancelSelectPricing={handleCancelSelectPricing}
                                        onConfirmSuccess={handleConfirmSuccess}
                                    />
                                </div>
                            </div>
                        )}
                </div>)
                : (
                    <div className="no-property-container">
                        <img src={OwnerPropertyImage} alt="No properties registered" className="building-image" />
                        <p className="no-property-text">
                            No property registered yet! Click{' '}
                            <a href="" className="register-link" onClick={AddProperty}>Register New Property</a>{' '}
                            to get started and add your first property.
                        </p>
                    </div>
                )}
        </div>
    );
};

export default OwnerParkinglotRegistration;
